import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-dialoge-affect',
  templateUrl: './dialoge-affect.component.html',
  styleUrls: ['./dialoge-affect.component.css']
})
export class DialogeAffectComponent implements OnInit {
  @Output()openModel:EventEmitter<void>=new EventEmitter()
  @Output()cancel: EventEmitter<void> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

}
